import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { PaginatedResponse, UserProcess, ManagerOfCompany, SearchProcessesOfManagedEmployees } from '@interfaces';
import { environment } from '@environment';

@Injectable({
  providedIn: 'root',
})
export class ManagerHttpService {
  private API_URL = environment.API_URL;
  private defaultOpts = { withCredentials: true };

  constructor(private http: HttpClient) {}

  public getMyManagedCompanies(): Observable<ManagerOfCompany[]> {
    const url = `${this.API_URL}/iammngr/companies`;
    return this.http.get<ManagerOfCompany[]>(url);
  }

  public searchProcessesOfManagedEmployees(
    payload: SearchProcessesOfManagedEmployees
  ): Observable<PaginatedResponse<Partial<UserProcess>>> {
    const url = `${this.API_URL}/iammngr/processes/search`;
    return this.http.post<PaginatedResponse<Partial<UserProcess>>>(url, payload);
  }
}
